class SortBy extends HTMLElement {
  constructor() {
    super();

    this.select_element = this.querySelector('select');
    this.sectionId = this.getAttribute('data-section-id');
  }

  replaceCurrentHistory(url) {
    history.replaceState({}, '', url);
  }

  async loadAndInjectProducts() {
    this.sectionIdURL = new URL(this.currentLocation.href);
    this.sectionIdURL.searchParams.set('sections', this.sectionId);
    
   var productHTML = await fetch(this.sectionIdURL.toString())
    .then(res => {  return res.json() })
     .then(resJSON => {
      return new DOMParser().parseFromString(resJSON[this.sectionId], "text/html"); 
     });

    // Keep keyboard focus on the sort if a theme layout puts it inside the part replaced here.
    var hadFocus = document.activeElement === this.select_element;
    document.querySelector('.template__collection-products').innerHTML = productHTML.querySelector('.template__collection-products').innerHTML;
    // The applied filters' scrolling row in the new part gets its fade and arrows (storefront-filtering.js).
    if (typeof initPillScrollers === 'function') initPillScrollers(document.querySelector('.template__collection-products'));
    // The floating Filtre watches the tools row's Filtre, which may have been replaced just now (storefront-filtering.js).
    if (typeof window.ecFilterStickyRewatch === 'function') window.ecFilterStickyRewatch();
    if (hadFocus) {
      var next = document.getElementById('resource-sort-by');
      if (next) next.focus();
    }
  }
  
  sortBy() {
    /* getting current URL with params, stripping "page" param, and adding "sort_by" */
    this.currentLocation = new URL(window.location.href);
    this.currentLocation.searchParams.delete('page');

    this.currentLocation.searchParams.set('sort_by', this.sortByValue);
    /* sortBy value can only be equal to empty string when it's equal to the collections "default_sort_by" prop */
    if (this.sortByValue == '') {
      this.currentLocation.searchParams.delete('sort_by');
    }
    
    /* update URL in users navigation bar */
    this.replaceCurrentHistory(this.currentLocation.toString());

    this.loadAndInjectProducts();
  }


  listenForInteraction() {
    this.select_element.addEventListener('change', (changeEvt) => {
        this.selectedOption = this.select_element.options[this.select_element.selectedIndex];
        this.sortByValue = this.selectedOption.value;

        if (this.selectedOption.hasAttribute('data-is-default')) {
          this.sortByValue = ''; // prevent setting default sort by option
        }

        // The results line's sort (snippets/collection-sorting.liquid) sits outside the replaced part: keep its green
        // state and its spoken name ("Sortering: <current>") current here.
        var box = this.closest('.resource-sort-by--results');
        if (box) {
          box.classList.toggle('is-active', !this.selectedOption.hasAttribute('data-is-default'));
          var label = this.select_element.getAttribute('data-label');
          if (label) this.select_element.setAttribute('aria-label', label);
        }

        this.sortBy();
    });
  }

  connectedCallback() {
    this.listenForInteraction();
  }
}

customElements.define('wdn-collection-sort', SortBy);
